export const BITES_ORGANIZATION_ID = 1;
